import {
    Box,
    FormControl,
    FormLabel,
    Input,
    Select,
    Grid,
    GridItem,
    Textarea,
    Text,
    FormErrorMessage,
    Tag,
    TagLabel,
    TagCloseButton,
    Wrap,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

const DynamicFormContainer = ({ title, cardData, formData, setFormData, width, errors }) => {
    const { fields } = cardData;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleMultiSelectChange = (name, value) => {
        setFormData((prev) => {
            const selectedValues = prev[name] || [];
            return {
                ...prev,
                [name]: selectedValues.includes(value)
                    ? selectedValues.filter((item) => item !== value)
                    : [...selectedValues, value],
            };
        });
    };

    const handleRemoveMultiSelect = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: prev[name].filter((item) => item !== value),
        }));
    };

    return (
        <Box bg="white" p={6} boxShadow="lg" borderRadius="lg" width={width}>
            <Text fontFamily="'Roboto', sans-serif"
                fontWeight="700"
                fontSize="18px"
                lineHeight="27px"
                color="rgb(31, 39, 51)">
                {title}
            </Text>
            <Grid templateColumns="repeat(12, 1fr)" mt={6} gap={4}>
                {fields.map((field) => {
                    if (field.conditional && !field.conditional(formData)) {
                        return null;
                    }

                    const fieldValue = formData[field.name] ?? field.value ?? "";

                    return (
                        <GridItem key={field.name} colSpan={field.gridSize || 12}>
                            <FormControl isInvalid={!!errors[field.name]}>
                                <FormLabel
                                    fontFamily="'Roboto', sans-serif"
                                    fontWeight="700"
                                    fontSize="12px"
                                    lineHeight="18px"
                                    color="rgb(26, 32, 44)"
                                >
                                    {field.label} {field.required && <Text as="span" color="red.500">*</Text>}
                                </FormLabel>

                                {/* Multi-Select Field */}
                                {field.type === "multi-select" ? (
                                    <>
                                        <Wrap mb={2}>
                                            {(fieldValue.length ? fieldValue : []).map((value) => (
                                                <Tag
                                                    size="sm"
                                                    key={value}
                                                    borderRadius="full"
                                                    variant="solid"
                                                    bg="teal.500"
                                                    color="white"
                                                    fontFamily="Roboto, serif"
                                                >
                                                    <TagLabel>{value}</TagLabel>
                                                    <TagCloseButton onClick={() => handleRemoveMultiSelect(field.name, value)} />
                                                </Tag>
                                            ))}
                                        </Wrap>
                                        <Menu>
                                            <MenuButton
                                                as={Button}
                                                rightIcon={<ChevronDownIcon />}
                                                width="100%"
                                                textAlign="left"
                                                bg="white"
                                                border="1px solid"
                                                borderColor="gray.300"
                                                fontFamily="Roboto, serif"
                                            >
                                                Select Options
                                            </MenuButton>
                                            <MenuList bg="white" borderColor="gray.200">
                                                {field.options.map((opt) => (
                                                    <MenuItem
                                                        key={opt}
                                                        onClick={() => handleMultiSelectChange(field.name, opt)}
                                                        fontFamily="Roboto, serif"
                                                    >
                                                        {opt}
                                                    </MenuItem>
                                                ))}
                                            </MenuList>
                                        </Menu>
                                    </>
                                ) : field.type === "select" ? (
                                    // Dropdown Select Field
                                    <Select
                                        name={field.name}
                                        onChange={handleChange}
                                        value={fieldValue}
                                        borderRadius="15px"
                                        fontSize="xs" placeholder={field.placeholder || `Enter ${field.label}`} color="gray.400"
                                    >

                                        {/* <option value="">Select {field.label}</option> */}
                                        {field.options.map((opt) => (
                                            <option key={opt} value={opt}>
                                                {opt}
                                            </option>
                                        ))}
                                    </Select>
                                ) : field.type === "textarea" ? (
                                    // Textarea Field
                                    <Textarea
                                        name={field.name}
                                        onChange={handleChange}
                                        value={fieldValue}
                                        minH="120px"
                                        placeholder={field.placeholder || `Enter ${field.label}`}
                                        fontSize="xs"
                                        borderRadius="15px"
                                    />
                                ) : (
                                    // Input Field (Text, Email, Number, etc.)
                                    // <Input
                                    //     type={field.type}
                                    //     name={field.name}
                                    //     placeholder={field.placeholder || `Enter ${field.label}`} // Dynamic Placeholder
                                    //     onChange={handleChange}
                                    //     value={fieldValue}
                                    //     fontSize="xs"
                                    //     px={4}
                                    //     height={10}
                                    //     borderRadius="15px"
                                    //     border="1px solid"
                                    //     borderColor="inherit"
                                    //     background="inherit"
                                    //     width="100%"
                                    //     minWidth="0px"
                                    //     outline="2px solid transparent"
                                    //     outlineOffset="2px"
                                    //     position="relative"
                                    //     appearance="none"
                                    //     transitionProperty="common"
                                    //     transitionDuration="normal"
                                    //     fontFamily="'Roboto', sans-serif"
                                    //     fontWeight="700"
                                    //     fontSize="12px"
                                    //     lineHeight="18px"
                                    //     color="rgb(26, 32, 44)"
                                    //     _placeholder={{
                                    //         fontFamily: "'Roboto', sans-serif",
                                    //         fontWeight: "400",
                                    //         fontSize: "12px",
                                    //         lineHeight: "18px",
                                    //         color: "rgb(183, 193, 215)",
                                    //     }}
                                    // />
                                    <Input
                                        borderRadius="15px"
                                        // placeholder="eg. Summer"
                                        fontSize="xs"
                                        type={field.type}
                                        name={field.name}
                                        placeholder={field.placeholder || `Enter ${field.label}`}
                                        onChange={handleChange}
                                        value={fieldValue}
                                    />


                                )}

                                <FormErrorMessage fontFamily="Roboto, serif">{errors[field.name]}</FormErrorMessage>
                            </FormControl>
                        </GridItem>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default DynamicFormContainer;
